export default "__VITE_ASSET__CX4JbqeW__"